module.exports = __webpack_public_path__ + "static/img/wood22.956cf55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood22.jpg
// module id = 0sCT
// module chunks = 0